var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"d-flex justify-content-center title"},[_vm._v("404 Not Found")])
}
var staticRenderFns = []

export { render, staticRenderFns }